import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatDate } from "../../../../common/Validations";

const EstimationDetailsModal = ({ show, onHide, rowData }) => {
  if (!rowData) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Estimation Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex flex-column gap-2">
          <p>
            <strong>Est Create Date:</strong>{" "}
            {formatDate(rowData?.tenestinationDate)}
          </p>
          <p>
            <strong>Est Start Date:</strong>{" "}
            {formatDate(rowData?.estimateStartdat)}
          </p>
          <p>
            <strong>Est End Date:</strong>{" "}
            {formatDate(rowData?.estimateEndDate)}
          </p>
          <p>
            <strong>Sales Officer:</strong> {rowData?.salesOfficerName || "--"}
          </p>
          <p>
            <strong>Remark:</strong> {rowData?.qtn_Job_Remarks || "--"}
          </p>
          <p>
            <strong>Qtn Nr:</strong> {rowData?.quotationNr || "--"}
          </p>
          <p>
            <strong>Job Nr:</strong> {rowData?.transactionNr || "--"}
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EstimationDetailsModal;
